import React, { useEffect, useState, useRef, useContext } from "react";
import PubSub from "pubsub-js";
import CarouselMouseMove from "../ui/CarouselMouseMove";
import Texte from "../modules/Texte";
import Variations from "./Variations";
import SanityImage from "../SanityImage";
import { _localizeText, _localizeField } from "../../core/utils";
// import { WrapperContext } from "../Layout";
import { LocaleContext } from "../ui/LocaleWrapper";

const Product = ({ url, input }) => {
  const { localeCtx } = useContext(LocaleContext);

  const { _id, slug, texte, seo } = input;
  const { title, price, images, color, notice } = input.productInfos;

  const ctaRef = useRef();
  const [variation, setVariation] = useState(null);

  useEffect(() => {
    const tokenChange = PubSub.subscribe("VARIATION_CHANGE", (e, d) => {
      setVariation(d);
    });
    const tokenReset = PubSub.subscribe("VARIATION_RESET", (e) => {
      setVariation(null);
    });

    return () => {
      PubSub.unsubscribe(tokenChange);
      PubSub.unsubscribe(tokenReset);
    };
  }, []);

  const variationList = color
    .map((el) => _localizeField(el.title))
    .toString()
    .replace(",", "|");
  const variationDefault = variationList.split("|")[0];
  console.log("price", price);
  return (
    <section className='product' id={slug.current}>
      <div className='x'>
        <div className='summary h100'>
          <div className='tac'>
            <Variations input={{ label: "Color", variations: color }} />
            {notice && (
              <p className='product-notice mbS'>{_localizeField(notice)}</p>
            )}
            <button
              ref={ctaRef}
              className='snipcart-add-item cta'
              data-item-id={slug.current}
              data-item-price={price}
              data-item-url={url}
              data-item-description={seo.metaDescription}
              data-item-image={
                variation ? variation.image.asset.url : images[0].asset.url
              }
              data-item-name={title}
              data-item-custom1-name={_localizeText("color")}
              // data-item-custom1-options={variationList}
              data-item-custom1-required='true'
              data-item-custom1-value={
                variation ? variation.title[localeCtx] : variationDefault
              }
              data-item-color-value={variationDefault}>
              {_localizeText("atc")} {price}€
            </button>
          </div>
        </div>
        <div className='images'>
          {variation ? (
            <div className='variation-image'>
              <SanityImage input={variation.image} />
            </div>
          ) : (
            <CarouselMouseMove input={images} />
          )}
        </div>
      </div>
      <div className='texte'>
        <Texte input={texte} />
      </div>
    </section>
  );
};

export default Product;
